import { useState } from 'react';
import Button from 'Components/Atoms/Button/Button';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { confirmProviderConnection } from 'Services/providersConnections';
import { useQueryClient } from '@tanstack/react-query';
import { useErrors } from 'Components/Organisms/ErrorsProvider';

export default function CreatingTotalMatch(props) {
    const { providerConnection, onClose, onClearConnection } = props;
    const [processing, setProcessing] = useState(false);
    const [loading, setLoading] = useState(false);
    const queryClient = useQueryClient();
    const { showUnknownError } = useErrors();

    const { t } = useTranslation('providers');

    const handleReject = async () => {
        if (loading) return;

        setProcessing(true);
        await onClearConnection();
        onClose();
    };

    const handleCreateAnyway = async () => {
        if (processing || loading) return;

        setLoading(true);

        try {
            await confirmProviderConnection(providerConnection.id);
            await queryClient.invalidateQueries({ queryKey: ['providers-connections'] });
            onClose();
        } catch (error) {
            showUnknownError(error);
            onClose();
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="text-center">
            <div className="flex justify-center mb-6">
                <img src="/img/icon-error.svg" alt="" />
            </div>
            <h3 className="font-medium">{t('creating-total-match-title')}</h3>
            <div className="mt-2 text-gray-500">{t('creating-total-match-description')}</div>
            <div className="mt-6 flex gap-4 justify-center">
                <Button variant="primary" isBusy={processing} onClick={handleReject}>
                    {t('close')}
                </Button>
                <Button variant="default" isBusy={loading} onClick={handleCreateAnyway}>
                    {t('create-anyway')}
                </Button>
            </div>
        </div>
    );
}

CreatingTotalMatch.propTypes = {
    providerConnection: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
    onClearConnection: PropTypes.func.isRequired,
};
